var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('sub-visual', {
    attrs: {
      "sh": "회사소개",
      "sc": "에프원시큐리티가 여러분의 정보를 함께 보호하겠습니다.",
      "tabActive": "인재채용",
      "icon": "/images/sub/visual/sv1-icon.svg",
      "bg": "/images/sub/visual/sv1.png"
    }
  }), _c('section', {
    staticClass: "sub-section pb-28 pb-md-28 pb-lg-54"
  }, [_c('v-container', [_c('div', {
    staticClass: "sub-tit-wrap"
  }, [_c('h3', {
    staticClass: "sub-tit--lg mb-12 mb-lg-24",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('span', {
    staticClass: "color-point"
  }, [_vm._v("F1 Security")]), _vm._v(" 의 문은 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" 항상 열려있습니다. ")]), _c('p', {
    staticClass: "page-text--lg color-gray"
  }, [_vm._v(" 보안전문가로서 F1 Security와 함께 발전 하고자 한다면 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" 망설이지 말고 문을 두드리시길 바랍니다. ")])])])], 1), _c('section', {
    staticClass: "recruitment-bg py-26 pb-lg-66"
  }, [_c('v-container', [_c('v-img', {
    staticClass: "d-block mx-auto",
    attrs: {
      "max-width": "624",
      "src": "/images/sub/about/recruitment/recruitment-img.png"
    }
  })], 1)], 1), _c('section', {
    staticClass: "sub-section-sm sub-section-sm--first"
  }, [_c('v-container', [_c('h4', {
    staticClass: "sub-tit--md line-height-1 mb-20 mb-lg-30",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("채용절차")]), _c('v-img', {
    staticClass: "d-none d-md-block mx-auto",
    attrs: {
      "max-width": "1107",
      "src": "/images/sub/about/recruitment/recruitment-img2.png"
    }
  }), _c('v-img', {
    staticClass: "d-block d-md-none mx-auto",
    attrs: {
      "max-width": "500",
      "src": "/images/sub/about/recruitment/recruitment-img2-mo.png"
    }
  })], 1)], 1), _c('section', {
    staticClass: "sub-section-sm"
  }, [_c('v-container', [_c('h4', {
    staticClass: "sub-tit--md line-height-1 mb-20 mb-lg-30",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("근무환경")]), _c('div', {
    staticClass: "bg-white recruitment-slide-wrap"
  }, [_c('div', {
    staticClass: "recruitment-slide"
  }, [_c('div', {
    staticClass: "swiper-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    staticClass: "d-block w-100",
    attrs: {
      "src": "/images/sub/about/recruitment/slide-img1.png",
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    staticClass: "d-block w-100",
    attrs: {
      "src": "/images/sub/about/recruitment/slide-img2.png",
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    staticClass: "d-block w-100",
    attrs: {
      "src": "/images/sub/about/recruitment/slide-img3.png",
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    staticClass: "d-block w-100",
    attrs: {
      "src": "/images/sub/about/recruitment/slide-img4.png",
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    staticClass: "d-block w-100",
    attrs: {
      "src": "/images/sub/about/recruitment/slide-img5.png",
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    staticClass: "d-block w-100",
    attrs: {
      "src": "/images/sub/about/recruitment/slide-img6.png",
      "alt": ""
    }
  })])])]), _c('div', {
    staticClass: "recruitment-btn recruitment-prev"
  }, [_c('i', {
    staticClass: "icon icon-arrow-left-sm"
  })]), _c('div', {
    staticClass: "recruitment-btn recruitment-next"
  }, [_c('i', {
    staticClass: "icon icon-arrow-right-sm"
  })]), _c('div', {
    staticClass: "recruitment-pagination"
  })]), _c('p', {
    staticClass: "page-text font-weight-bold text-center pa-18 border"
  }, [_vm._v(" 스낵바, 휴게실, 회의실, 카페테리아, 노트북, 사무용품 지급 ")])])])], 1), _c('section', {
    staticClass: "sub-section-sm sub-section--last"
  }, [_c('v-container', [_c('h4', {
    staticClass: "sub-tit--md line-height-1 mb-20 mb-lg-30",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("복리후생")]), _c('v-row', {
    staticClass: "my-lg-n10"
  }, [_c('v-col', {
    staticClass: "py-lg-10",
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "4"
    }
  }, [_c('div', {
    staticClass: "num-wrap pt-18 pt-lg-22 h-100",
    attrs: {
      "data-aos": "fade-right",
      "data-aos-delay": "100"
    }
  }, [_c('span', {
    staticClass: "num page-text"
  }, [_vm._v("01")]), _c('div', {
    staticClass: "h-100 radius-sm border pa-16 pt-34 pt-md-58 pb-md-50 d-flex flex-column align-center justify-center text-center"
  }, [_c('img', {
    staticClass: "d-block mb-12 mb-lg-24",
    attrs: {
      "src": "/images/sub/about/recruitment/recruitment-icon1.png",
      "alt": ""
    }
  }), _c('h5', {
    staticClass: "sub-tit--sm line-height-1 font-weight-bold mb- mb-8 mb-lg-20"
  }, [_vm._v(" 리프레시 ")]), _c('p', {
    staticClass: "page-text color-gray"
  }, [_vm._v(" 특별휴가, 근로자휴가 지원사업, "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" 산전 후 휴가, 육아휴직, 남성출산휴가 ")])])])]), _c('v-col', {
    staticClass: "py-lg-10",
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "4",
      "data-aos": "fade-right",
      "data-aos-delay": "400"
    }
  }, [_c('div', {
    staticClass: "num-wrap pt-18 pt-lg-22 h-100"
  }, [_c('span', {
    staticClass: "num page-text"
  }, [_vm._v("02")]), _c('div', {
    staticClass: "h-100 radius-sm border pa-16 pt-34 pt-md-58 pb-md-50 d-flex flex-column align-center justify-center text-center"
  }, [_c('img', {
    staticClass: "d-block mb-12 mb-lg-24",
    attrs: {
      "src": "/images/sub/about/recruitment/recruitment-icon2.png",
      "alt": ""
    }
  }), _c('h5', {
    staticClass: "sub-tit--sm line-height-1 font-weight-bold mb- mb-8 mb-lg-20"
  }, [_vm._v(" 지원금 · 보험 ")]), _c('p', {
    staticClass: "page-text color-gray"
  }, [_vm._v(" 본인학자금, 도서 구입 및 자격증 취득 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" 내일채움공제, 건강검진, 각종 경조사 지원 ")])])])]), _c('v-col', {
    staticClass: "py-lg-10",
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "4",
      "data-aos": "fade-right",
      "data-aos-delay": "700"
    }
  }, [_c('div', {
    staticClass: "num-wrap pt-18 pt-lg-22 h-100"
  }, [_c('span', {
    staticClass: "num page-text"
  }, [_vm._v("03")]), _c('div', {
    staticClass: "h-100 radius-sm border pa-16 pt-34 pt-md-58 pb-md-50 d-flex flex-column align-center justify-center text-center"
  }, [_c('img', {
    staticClass: "d-block mb-12 mb-lg-24",
    attrs: {
      "src": "/images/sub/about/recruitment/recruitment-icon3.png",
      "alt": ""
    }
  }), _c('h5', {
    staticClass: "sub-tit--sm line-height-1 font-weight-bold mb- mb-8 mb-lg-20"
  }, [_vm._v(" 교육 · 생활 ")]), _c('p', {
    staticClass: "page-text color-gray"
  }, [_vm._v(" 우수사원시상식, 신입사원교육(OJT), 워크샵, "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" 직무능력향상교육, 가족친화 우수기업 ")])])])]), _c('v-col', {
    staticClass: "py-lg-10",
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "4",
      "data-aos": "fade-right",
      "data-aos-delay": "1000"
    }
  }, [_c('div', {
    staticClass: "num-wrap pt-18 pt-lg-22 h-100"
  }, [_c('span', {
    staticClass: "num page-text"
  }, [_vm._v("04")]), _c('div', {
    staticClass: "h-100 radius-sm border pa-16 pt-34 pt-md-58 pb-md-50 d-flex flex-column align-center justify-center text-center"
  }, [_c('img', {
    staticClass: "d-block mb-12 mb-lg-24",
    attrs: {
      "src": "/images/sub/about/recruitment/recruitment-icon4.png",
      "alt": ""
    }
  }), _c('h5', {
    staticClass: "sub-tit--sm line-height-1 font-weight-bold mb- mb-8 mb-lg-20"
  }, [_vm._v(" 조직문화 ")]), _c('p', {
    staticClass: "page-text color-gray"
  }, [_vm._v(" 회식강요 안함, 야근강요 안함, 자유복장, "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" 자유로운 연차 사용 ")])])])]), _c('v-col', {
    staticClass: "py-lg-10",
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "4",
      "data-aos": "fade-right",
      "data-aos-delay": "1300"
    }
  }, [_c('div', {
    staticClass: "num-wrap pt-18 pt-lg-22 h-100"
  }, [_c('span', {
    staticClass: "num page-text"
  }, [_vm._v("05")]), _c('div', {
    staticClass: "h-100 radius-sm border pa-16 pt-34 pt-md-58 pb-md-50 d-flex flex-column align-center justify-center text-center"
  }, [_c('img', {
    staticClass: "d-block mb-12 mb-lg-24",
    attrs: {
      "src": "/images/sub/about/recruitment/recruitment-icon5.png",
      "alt": ""
    }
  }), _c('h5', {
    staticClass: "sub-tit--sm line-height-1 font-weight-bold mb- mb-8 mb-lg-20"
  }, [_vm._v(" 선물 ")]), _c('p', {
    staticClass: "page-text color-gray"
  }, [_vm._v(" 명절선물/귀향비, "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" 생일선물/파티 ")])])])]), _c('v-col', {
    staticClass: "py-lg-10",
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "4",
      "data-aos": "fade-right",
      "data-aos-delay": "1600"
    }
  }, [_c('div', {
    staticClass: "num-wrap pt-18 pt-lg-22 h-100"
  }, [_c('span', {
    staticClass: "num page-text"
  }, [_vm._v("06")]), _c('div', {
    staticClass: "h-100 radius-sm border pa-16 pt-34 pt-md-58 pb-md-50 d-flex flex-column align-center justify-center text-center"
  }, [_c('img', {
    staticClass: "d-block mb-12 mb-lg-24",
    attrs: {
      "src": "/images/sub/about/recruitment/recruitment-icon6.png",
      "alt": ""
    }
  }), _c('h5', {
    staticClass: "sub-tit--sm line-height-1 font-weight-bold mb- mb-8 mb-lg-20"
  }, [_vm._v(" 급여제도 ")]), _c('p', {
    staticClass: "page-text color-gray"
  }, [_vm._v(" 우수사원포상, 장기근속자 포상제도, "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" 퇴직금, 4대 보험 ")])])])])], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }